module.exports = __webpack_public_path__ + "img/loading.6e598655.svg";